import React from "react";
import "./TBTTheme.scss";

const TBTTheme = () => (
  <div className="product-hero-decoration" aria-hidden="true">
    <div className="product-hero-decoration-tr" />
    <div className="product-hero-decoration-br" />
    <div className="product-hero-decoration-tl" />
    <div className="product-hero-decoration-bl" />
  </div>
);

export default TBTTheme;
